import React from "react";

import ChevronLeft from "@material-ui/icons/ChevronLeft";

import { TopToolbar, ListButton, ShowButton } from "react-admin";

export const MyEditActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} label="Back" icon={<ChevronLeft />} />
    <ShowButton basePath={basePath} record={data} />
  </TopToolbar>
);
